import { Check } from "lucide-react";
import { Progress } from "@/components/ui/progress";

export default function Stepper({
  steps,
  current,
  pct,
  completedSteps = [],
  onNavigate,
}) {
  const canNavigate =
    typeof onNavigate === "function";

  return (
    <div className="bg-white border-b border-gray-200">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between mb-3 text-xs text-gray-600">
          <span
            className="font-semibold text-[#0F2D52]"
            data-testid="portal-progress-label"
          >
            {pct}% · {steps[current]}
          </span>

          <span>
            Step {current + 1} of {steps.length}
          </span>
        </div>

        <Progress
          value={pct}
          data-testid="portal-progress-bar"
          className="h-1.5 bg-gray-100 [&>*]:bg-[#0F2D52]"
        />

        <div className="mt-4 overflow-x-auto">
          <div className="flex items-center gap-1 min-w-max">
            {steps.map((step, index) => {
              const active =
                index === current;

              const completed =
                completedSteps.includes(index);

              return (
                <button
                  key={step}
                  type="button"
                  onClick={() => {
                    if (canNavigate) {
                      onNavigate(index);
                    }
                  }}
                  disabled={!canNavigate}
                  data-testid={`portal-step-${index}`}
                  aria-current={
                    active ? "step" : undefined
                  }
                  className={`text-[11px] font-semibold px-2.5 py-1.5 rounded-full whitespace-nowrap flex items-center gap-1 mm-transition ${
                    active
                      ? "bg-[#0F2D52] text-white"
                      : completed
                        ? "bg-[#16A34A]/10 text-[#16A34A] hover:bg-[#16A34A]/15 cursor-pointer"
                        : canNavigate
                          ? "text-gray-500 hover:bg-gray-100 hover:text-[#0F2D52] cursor-pointer"
                          : "text-gray-400"
                  }`}
                >
                  {completed && (
                    <Check className="h-3 w-3" />
                  )}

                  <span className="uppercase tracking-wider text-[10px]">
                    {step}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}